"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAugmentationBoxes = exports.rotateBoundingBox = exports.scaleBoundingBox = void 0;
var lodash_1 = __importDefault(require("lodash"));
var scaleBoundingBox = function (box, scale) {
    return { x: box.x * scale, y: box.y * scale, width: box.width * scale, height: box.height * scale };
};
exports.scaleBoundingBox = scaleBoundingBox;
function normalizeAngle(angle) {
    var normalizedAngle = angle % 360;
    return (normalizedAngle < 0 ? normalizedAngle + 360 : normalizedAngle);
}
var rotateBoundingBox = function (box, rotation, canvasSize) {
    var normalizedAngle = normalizeAngle(rotation);
    if (normalizedAngle === 0) {
        return box;
    }
    if (normalizedAngle === 90) {
        return { x: canvasSize.width - box.y - box.height, y: box.x, width: box.height, height: box.width };
    }
    if (normalizedAngle === 180) {
        return __assign(__assign({}, box), { x: canvasSize.width - box.x - box.width, y: canvasSize.height - box.y - box.height });
    }
    return { x: box.y, y: canvasSize.height - box.x - box.width, width: box.height, height: box.width };
};
exports.rotateBoundingBox = rotateBoundingBox;
function transformBoundingBoxes(rectangle, scale, size, inset, rotation) {
    if (!rectangle) {
        if (inset) {
            var left = inset.left, right = inset.right, top_1 = inset.top, bottom = inset.bottom;
            return { x: left, y: top_1, width: size.width - left - right, height: size.height - top_1 - bottom };
        }
        return { x: 0, y: 0, width: size.width, height: size.height };
    }
    var scaledBoundingBox = (0, exports.scaleBoundingBox)(rectangle, scale);
    return rotation ? (0, exports.rotateBoundingBox)(scaledBoundingBox, rotation, size) : (0, exports.scaleBoundingBox)(rectangle, scale);
}
function generateKeyForBoundingBoxCoordinates(rectangle) {
    return rectangle ? "".concat(rectangle.x, ":").concat(rectangle.y, ":").concat(rectangle.width, ":").concat(rectangle.height) : '';
}
function mergeAugmentationBoxes(boundingBoxes, showBoundingBox) {
    var result = [];
    var map = new Map();
    for (var i = 0; i < boundingBoxes.length; i++) {
        var boundingBoxItem = boundingBoxes[i];
        if (showBoundingBox[boundingBoxItem.noticeId]) {
            result.push(boundingBoxItem);
        }
        var key = generateKeyForBoundingBoxCoordinates(boundingBoxItem.rectangle);
        if (!map.has(key)) {
            map.set(key, boundingBoxItem.tagText);
        }
        else {
            map.set(key, "".concat(map.get(key), ", ").concat(boundingBoxItem.tagText));
        }
    }
    return lodash_1.default.uniqWith(result.map(function (boundingBoxItem) {
        var tagText = map.get(generateKeyForBoundingBoxCoordinates(boundingBoxItem.rectangle));
        return { rectangle: boundingBoxItem.rectangle, tagText: tagText };
    }), lodash_1.default.isEqual);
}
var transformAugmentationBoxes = function (augmentationBoxes, containerStyle, showBoundingBox) {
    var e_1, _a;
    if (containerStyle) {
        var mergedAugmentationBoxes = mergeAugmentationBoxes(augmentationBoxes, showBoundingBox);
        var inset = containerStyle.inset, rotation = containerStyle.rotation, scale = containerStyle.scale, size = containerStyle.size; // containerStyle.size is after rotation & scale
        var boundingBoxesInsideImage = [];
        var boundingBoxesOnWholeImage = [];
        try {
            for (var mergedAugmentationBoxes_1 = __values(mergedAugmentationBoxes), mergedAugmentationBoxes_1_1 = mergedAugmentationBoxes_1.next(); !mergedAugmentationBoxes_1_1.done; mergedAugmentationBoxes_1_1 = mergedAugmentationBoxes_1.next()) {
                var _b = mergedAugmentationBoxes_1_1.value, tagText = _b.tagText, rectangle = _b.rectangle;
                var result = {
                    tagText: tagText,
                    rectangle: transformBoundingBoxes(rectangle, scale, size, inset, rotation),
                };
                rectangle ? boundingBoxesInsideImage.push(result) : boundingBoxesOnWholeImage.push(result);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mergedAugmentationBoxes_1_1 && !mergedAugmentationBoxes_1_1.done && (_a = mergedAugmentationBoxes_1.return)) _a.call(mergedAugmentationBoxes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return [boundingBoxesInsideImage, boundingBoxesOnWholeImage];
    }
    return [[], []];
};
exports.transformAugmentationBoxes = transformAugmentationBoxes;
